const context = "vendas";
const abrev = "ven";

// http://projetos.sovis.com.br/projects/soviswebfv/wiki/Criando_p%C3%A1ginas_com_rotas_aninhadas
const MODULO_ATIVIDADE   = "AGENDAATIVIDADE";
const MODULO_ATENDIMENTO = "ATENDIMENTOAGRICOLA";

const vendas = [
    {
        path: '/ven/pedido',
        name: 'ven-pedido',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/pedido/Pedido.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-pedido-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/pedido/PedidoList.vue'),
                children: [
                    {
                        path: ':id/:origem',
                        name: 'ven-pedido-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/pedido/PedidoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/status-comercial',
        name: 'status-comerciais',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/Statuscomerciais.vue'),
        children: [
            {
                path: 'edit/:id',
                name: 'edit-status-comercial',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/Statuscomercial.vue')
            },
        ]
    },
    {
        path: '/ven/motivonaovenda',
        name: 'venda-motivo-nao-venda',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/motivo-nao-venda/MotivoNaoVenda.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-motivo-nao-venda-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/motivo-nao-venda/MotivoNaoVendaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-motivo-nao-venda-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/motivo-nao-venda/MotivoNaoVendaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-motivo-nao-venda-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/motivo-nao-venda/MotivoNaoVendaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/campanha',
        name: 'ven-campanha',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/campanha/Campanha.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-campanha-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/campanha/CampanhaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-campanha-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/campanha/CampanhaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-campanha-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/campanha/CampanhaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/forma-recebimento',
        name: 'ven-forma-recebimento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/forma-recebimento/FormaRecebimento.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-forma-recebimento-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/forma-recebimento/FormaRecebimentoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-forma-recebimento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/forma-recebimento/FormaRecebimentoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-forma-recebimento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/forma-recebimento/FormaRecebimentoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/prazo-pagamento',
        name: 'ven-prazo-pagamento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/prazo-pagamento/PrazoPagamento.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-prazo-pagamento-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/prazo-pagamento/PrazoPagamentoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-prazo-pagamento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/prazo-pagamento/PrazoPagamentoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-prazo-pagamento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/prazo-pagamento/PrazoPagamentoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/tabpreco',
        name: 'ven-tabelapreco',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/tabelapreco/Tabelapreco.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-tabelapreco-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/tabelapreco/TabelaprecoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-tabelapreco-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tabelapreco/TabelaprecoManage.vue')
                    },
                    {
                        path: 'edit/:id/',
                        name: 'ven-tabelapreco-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tabelapreco/TabelaprecoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/moeda',
        name: 'ven-moeda',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/moeda/Moeda.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-moeda-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/moeda/MoedaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-moeda-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/moeda/MoedaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-moeda-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/moeda/MoedaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/forma-pagamento',
        name: 'ven-forma-pagamento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/forma-pagamento/FormaPagamento.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-forma-pagamento-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/forma-pagamento/FormaPagamentoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-forma-pagamento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/forma-pagamento/FormaPagamentoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-forma-pagamento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/forma-pagamento/FormaPagamentoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/tipopedido',
        name: 'ven-tipopedido',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/tipopedido/TipoPedido.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-tipopedido-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/tipopedido/TipoPedidoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-tipopedido-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tipopedido/TipoPedidoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-tipopedido-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tipopedido/TipoPedidoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/rentabilidade',
        name: 'ven-rentabilidade',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/rentabilidade/Rentabilidade.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-rentabilidade-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/rentabilidade/RentabilidadeList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-rentabilidade-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/rentabilidade/RentabilidadeManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-rentabilidade-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/rentabilidade/RentabilidadeManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/grupocomissao',
        name: 'ven-grupocomissao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/grupocomissao/GrupoComissao.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-grupocomissao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/grupocomissao/GrupoComissaoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-grupocomissao-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/grupocomissao/GrupoComissaoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-grupocomissao-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/grupocomissao/GrupoComissaoManage.vue')
                    },
                ]
            },
        ]
    },
];

const clientes = [
    {
        path: '/ven/cliente',
        name: 'ven-cliente',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/cliente/ClienteRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-cliente-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/cliente/ClienteListRoute.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-cliente-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'ven-cliente-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/cliente/ClienteManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'ven-cliente-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaDadosCadastraisRoute.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'ven-cliente-politica-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaPoliticaComercial.vue')
                            },
                            {
                                path: 'analise-comercial',
                                name: 'ven-cliente-analise-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaAnaliseComercial.vue')
                            },
                        ]
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-cliente-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'ven-cliente-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/cliente/ClienteManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'ven-cliente-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaDadosCadastraisRoute.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'ven-cliente-politica-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaPoliticaComercial.vue')
                            },
                            {
                                path: 'analise-comercial',
                                name: 'ven-cliente-analise-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaAnaliseComercial.vue')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    {
		path: '/ven/clientes/grupoeconomico',
		name: 'ven-grupoeconomico',
        meta: { contexto: context, abrev: abrev },
		component: () => import('@/components/agro/grupoeconomico/GrupoEconomico'),
		children: [
			{
				path: 'list',
				name: 'ven-grupoeconomico-list',
				meta: { contexto: context, abrev: abrev },
				component: () => import('@/components/agro/grupoeconomico/GrupoEconomicoList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-grupoeconomico-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/grupoeconomico/GrupoEconomicoManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-grupoeconomico-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/grupoeconomico/GrupoEconomicoManage')
                    } 
                ]
			},
		]
	},
    {
        path: '/ven/clientes/regiao',
        name: 'ven-regiao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/regiao/RegiaoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-regiao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/regiao/RegiaoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-regiao-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/regiao/RegiaoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-regiao-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/regiao/RegiaoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/clientes/tipoendereco',
        name: 'ven-tipoendereco',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/tipoendereco/TipoEndereco.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-tipoendereco-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/tipoendereco/TipoEnderecoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-tipoendereco-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tipoendereco/TipoEnderecoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-tipoendereco-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tipoendereco/TipoEnderecoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/clientes/transportadora',
        name: 'ven-transportadora',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/transportadora/Transportadora.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-transportadora-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/transportadora/TransportadoraList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-transportadora-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/transportadora/TransportadoraManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-transportadora-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/transportadora/TransportadoraManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/clientes/situacao',
        name: 'ven-situacao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/situacao/Situacao.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-situacao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/situacao/SituacaoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-situacao-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/situacao/SituacaoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-situacao-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/situacao/SituacaoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/clientes/leads',
        name: 'ven-leads',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/leads/Leads.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-leads-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/leads/LeadsList.vue'),
                children: [
                    {
                        path: 'view/:id',
                        name: 'ven-leads-view',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/leads/LeadsView.vue'),
                        props: true
                    },
                ]
            },
        ]
    },
];

const empresas = [
    {
        path: '/ven/empresa',
        name: 'ven-empresa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/empresa/EmpresaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-empresa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/empresa/EmpresaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-empresa-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'ven-empresa-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'ven-empresa-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaDadosCadastrais.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'ven-empresa-politica-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaPoliticaComercial.vue')
                            },
                        ]
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-empresa-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'ven-empresa-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'ven-empresa-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaDadosCadastrais.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'ven-empresa-politica-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaPoliticaComercial.vue')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/empresas/turno',
        name: `vendas-turnos`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/turno/TurnoRoute.vue'),
        children: [
            {
                path: 'list',
                name: `vendas-turno-list`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/turno/TurnoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: `vendas-turno-new`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: `vendas-turno-edit`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/empresas/feriado',
        name: `vendas-feriados`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/feriado/FeriadoRoute.vue'),
        children: [
            {
                path: 'list',
                name: `vendas-feriados-list`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/feriado/FeriadoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: `vendas-feriados-new`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: `vendas-feriados-edit`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue')
                    },
                ]
            },
        ]
    },
];

const produtos = [
    {
        path: '/ven/produto',
        name: 'ven-produto',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/produto/Produto.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-produto-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/produto/ProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-produto-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'ven-produto-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/produto/ProdutoManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'ven-produto-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/produto/AbaDadosCadastrais.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'ven-produto-politica-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/produto/AbaPoliticaComercial.vue')
                            },
                            {
                                path: 'analise-comercial',
                                name: 'ven-produto-analise-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/produto/AbaAnaliseComercial.vue')
                            },
                        ]
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-produto-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'ven-produto-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/produto/ProdutoManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'ven-produto-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/produto/AbaDadosCadastrais.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'ven-produto-politica-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/produto/AbaPoliticaComercial.vue')
                            },
                            {
                                path: 'analise-comercial',
                                name: 'ven-produto-analise-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/produto/AbaAnaliseComercial.vue')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    // @84624 - Criação das rotas de grupo produto no modulo de vendas
    {
        path: '/ven/produtos/grupo',
        name: 'ven-produto-grupo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/grupo-produto/GrupoProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-produto-grupo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/grupo-produto/GrupoProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-produto-grupo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/grupo-produto/GrupoProdutoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-produto-grupo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/grupo-produto/GrupoProdutoManage.vue')
                    },
                ],
            },
        ]
    },
    // @84563 - Criação das rotas de subgrupo produto no modulo de vendas
    {
        path: '/ven/produtos/subgrupo',
        name: 'ven-produto-subgrupo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/subgrupo-produto/SubGrupoProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-produto-sub-grupo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/subgrupo-produto/SubGrupoProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-produto-sub-grupo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/subgrupo-produto/SubGrupoProdutoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-produto-sub-grupo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/subgrupo-produto/SubGrupoProdutoManage.vue')
                    },
                ],
            },
        ]
    },
    {
        path: '/ven/produtos/linha',
        name: 'ven-produto-linha',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/linha-produto/LinhaProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-produto-linha-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/linha-produto/LinhaProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-produto-linha-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/linha-produto/LinhaProdutoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-produto-linha-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/linha-produto/LinhaProdutoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/produtos/categoria',
        name: 'ven-categoria',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/categoria/Categoria.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-categoria-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/categoria/CategoriaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-categoria-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/categoria/CategoriaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-categoria-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/categoria/CategoriaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/produtos/lote',
        name: 'ven-produto-lote',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/lote/Lote.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-produto-lote-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/lote/LoteList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-produto-lote-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/lote/LoteManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-produto-lote-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/lote/LoteManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/produtos/fornecedor',
        name: 'ven-fornecedor',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/fornecedor/Fornecedor.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-fornecedor-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/fornecedor/FornecedorList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-fornecedor-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/fornecedor/FornecedorManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-fornecedor-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/fornecedor/FornecedorManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/produtos/pacotekit',
        name: 'ven-pacote-kit',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/pacote-kit/PacoteKit.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-pacote-kit-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/pacote-kit/PacoteKitList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-pacote-kit-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/pacote-kit/PacoteKitManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-pacote-kit-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/pacote-kit/PacoteKitManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/produtos/unidade-medida',
        name: 'venda-unidades-medida',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/unidade-medida/UnidadeMedida.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-unidade-medida-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/unidade-medida/UnidadeMedidaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-unidade-medida-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/unidade-medida/UnidadeMedidaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-unidade-medida-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/unidade-medida/UnidadeMedidaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/work-flow-situacao-pedido',
        name: 'work-flow-situacao-pedido',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/work-flow-situacao-pedido/WorkFlowSituacaoPedidoManage.vue'),
    },
    {
        path: '/ven/produtos/licenca',
        name: 'licencas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/licenca/Licenca.vue'),
        children: [
            {
                path: 'list',
                name: 'licenca-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/licenca/LicencaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'new-licenca',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/licenca/LicencaManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'edit-licenca',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/licenca/LicencaManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/produtos/catalogo',
        name: 'ven-produto-catalogo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/catalogo/Catalogo.vue')
    },
    {
        path: '/ven/grade',
        name: 'ven-grade',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/grade/Grade.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-grade-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/grade/GradeList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-grade-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/grade/GradeManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-grade-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/grade/GradeManage.vue')
                    },
                ]
            },
        ]
    },
];

const geoanalise = [
    {
        path: '/ven/geoanalise/clientesvendedor',
        name: 'mapa-clientes-vendedor',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/geoanalise/MapaClientesVendedor.vue')
    },
    {
        path: '/ven/geoanalise/statuscomercialcidade',
        name: 'mapa-status-comercial-cidade',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/geoanalise/MapaStatusComercialCidade.vue')
    },
    {
        path: '/ven/geoanalise/statuscomercialcliente',
        name: 'mapa-status-comercial-cliente',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/geoanalise/MapaStatusComercialCliente.vue')
    },
    {
        path: '/ven/geoanalise/localizacaovendedor',
        name: 'mapa-localizacao-vendedor',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/geoanalise/LocalizacaoVendedor.vue')
    },
    {
        path: '/ven/geoanalise/rotas',
        name: 'relatorio-vendas-rotas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/geoanalise/rotas/Rotas.vue')
    },
];

const relatorios = [
    {
        path: '/ven/exportacao/exportacaodados',
        name: 'relatorio-exportacao-dados',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/exportacao/ExportacaoDados.vue'),
        children: [
            {
                path: '/ven/relatorios/exportacaodetalhes/:id',
                name: 'relatorio-exportacao-detalhes',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/exportacao/ExportacaoDetalhes.vue')
            },
        ]
    },
    {
        path: '/ven/relatorios/comparativovendas',
        name: 'relatorio-vendas-comparativo-vendas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/ComparativoVendas.vue')
    },
    {
        path: '/ven/relatorios/faturamento',
        name: 'relatorio-vendas-faturamento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/Faturamento.vue')
    },
    {
        path: '/ven/relatorios/percentualparticipacao',
        name: 'relatorio-vendas-percentual-participacao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/PercentualParticipacao.vue')
    },
    {
        path: '/ven/relatorios/vendasperiodo',
        name: 'relatorio-vendas-vendas-por-periodo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/VendasPeriodo.vue')
    },
    {
        path: '/ven/relatorios/justificativanaovenda',
        name: 'relatorio-vendas-justificativa-nao-venda',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/JustificativaNaoVenda.vue')
    },
    {
        path: '/ven/relatorios/justificativanaovenda-detalhado/:idnaovenda',
        name: 'relatorio-vendas-justificativa-nao-venda-detalhada',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/JustificativaNaoVendaDetalhada.vue')
    },
    {
        path: '/ven/relatorios/resultado-objetivo-vendas',
        name: 'relatorio-vendas-resultado-objetivo-vendas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/relatorios/ResultadoObjetivoVendas.vue')
    },
    {
        path: '/ven/relatorios/check-in-out',
        name: 'relatorio-ven-check-in-out',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/vendas/relatorios/relatorio-ven-check-in-out/RelatorioVenCheckInOutRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-ven-check-in-out-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/vendas/relatorios/relatorio-ven-check-in-out/RelatorioVenCheckInOutListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/vendas/relatorio-analitico/ausencia-checkin-cliente',
        name: 'ausencia-checkin-cliente',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/vendas/relatorios/relatorio-analitico/relatorio-ausencia-checkin/RelatorioAusenciaCheckinRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'ausencia-checkin-cliente-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/vendas/relatorios/relatorio-analitico/relatorio-ausencia-checkin/RelatorioAusenciaCheckinListRoute.vue'
                    ),
            },
        ],
    },
];

const relatorioIntegradoErp = [
    {
        path: '/ven/relatorio-integrado-erp/gerencial-integrado',
        name: 'relatorio-ven-gerencial-integrado',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/vendas/relatorio-integrado-erp/gerencial-integrado/RelatorioGerencialIntegradoRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'gerencial-integrado-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/vendas/relatorio-integrado-erp/gerencial-integrado/RelatorioGerencialIntegradoList.vue'
                    ),
            },
        ],
    },
];

const crm = [
    // Atividades -->
    {
        path: '/ven/crm/atividade',
        name: 'venda-atividades',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
        component: () => import('@/components/vendas/agenda/old/AgendaAtividades.vue'),
        children: [
            {
                path: 'new',
                name: 'new-venda-atividade',
                meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                component: () => import('@/components/vendas/agenda/old/AgendaAtividade.vue')
            },
            {
                path: 'edit/:id',
                name: 'edit-venda-atividade',
                meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                component: () => import('@/components/vendas/agenda/old/AgendaAtividade.vue')
            },
        ]
    },
    {
        path: '/ven/crm/agenda',
        name: 'crm-agenda',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
        component: () => import('@/components/vendas/agenda/AgendaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'crm-agenda-list',
                meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                component: () => import('@/components/vendas/agenda/AgendaListRoute.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'crm-agenda-new',
                        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                        component: () => import('@/components/vendas/agenda/AgendaManageRoute.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'crm-agenda-edit',
                        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                        component: () => import('@/components/vendas/agenda/AgendaManageRoute.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/ven/crm/tipo-agenda',
        name: 'ven-tipo-agenda',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
        component: () => import('@/components/vendas/tipo-agenda-atividade/TipoAgendaAtividade.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-tipo-agenda-list',
                meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                component: () => import('@/components/vendas/tipo-agenda-atividade/TipoAgendaAtividadeList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-tipo-agenda-new',
                        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                        component: () => import('@/components/vendas/tipo-agenda-atividade/TipoAgendaAtividadeManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-tipo-agenda-edit',
                        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATIVIDADE },
                        component: () => import('@/components/vendas/tipo-agenda-atividade/TipoAgendaAtividadeManage.vue')
                    }
                ]
            }
        ]
    },
    // Atendimento Old -->
    {
        path: '/ven/crm/atendimento',
        name: 'venda-atendimentos-agricola',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATENDIMENTO },
        component: () => import('@/components/vendas/atendimento/old/Atendimentos.vue'),
        children: [
            {
                path: 'edit/:id',
                name: 'edit-venda-atendimento-agricola',
                meta: { contexto: context, abrev: abrev, modulo: MODULO_ATENDIMENTO },
                component: () => import('@/components/vendas/atendimento/old/Atendimento.vue')
            },
        ]
    },
    // Atendimento -->
    {
        path: '/ven/atendimento',
        name: 'ven-atendimento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/atendimento/AtendimentoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-atendimento-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/atendimento/AtendimentoListRoute.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-atendimento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/atendimento/AtendimentoManageRoute.vue')
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'ven-atendimento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/atendimento/AtendimentoManageRoute.vue')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/cultura',
        name: 'ven-cultura',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/cultura/Cultura'),
        children: [
            {
                path: 'list',
                name: 'ven-cultura-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/cultura/CulturaList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-cultura-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultura/CulturaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-cultura-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultura/CulturaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/ocorrencia',
        name: 'ven-ocorrencia',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/ocorrencia/Ocorrencia'),
        children: [
            {
                path: 'list',
                name: 'ven-ocorrencia-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/ocorrencia/OcorrenciaList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-ocorrencia-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/ocorrencia/OcorrenciaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-ocorrencia-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/ocorrencia/OcorrenciaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/cultivar',
        name: 'ven-cultivar',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/cultivar/Cultivar'),
        children: [
            {
                path: 'list',
                name: 'ven-cultivar-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/cultivar/CultivarList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-cultivar-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultivar/CultivarManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-cultivar-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultivar/CultivarManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/fasefenologica',
        name: 'ven-fasefenologica',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/fasefenologica/FaseFenologica'),
        children: [
            {
                path: 'list',
                name: 'ven-fasefenologica-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/fasefenologica/FaseFenologicaList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-fasefenologica-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/fasefenologica/FaseFenologicaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-fasefenologica-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/fasefenologica/FaseFenologicaManage')
                    }
                ]
            },
        ]
    },
    {
        // Tabela: tiportr
        path: '/ven/tipo-agrovisita',
        name: 'ven-tipo-agrovisita',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisita'),
        children: [
            {
                path: 'list',
                name: 'ven-tipo-agrovisita-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisitaList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-tipo-agrovisita-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisitaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-tipo-agrovisita-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisitaManage')
                    }
                ]
            },
        ]
    },
    {
        // Tabela: assuntortr
        path: '/ven/assunto-agrovisita',
        name: 'ven-assunto-agrovisita',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisita'),
        children: [
            {
                path: 'list',
                name: 'ven-assunto-agrovisita-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisitaList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-assunto-agrovisita-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisitaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-assunto-agrovisita-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisitaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/safra',
        name: 'ven-safra',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/safra/Safra'),
        children: [
            {
                path: 'list',
                name: 'ven-safra-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/safra/SafraList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-safra-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/safra/SafraManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-safra-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/safra/SafraManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/crm/motivoatendimento',
        name: 'ven-motivo-atendimento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/motivo-atendimento/MotivoAtendimento.vue'),
        children: [
            {
                path: 'list',
                name: "ven-motivo-atendimento-list",
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/motivo-atendimento/MotivoAtendimentoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-motivo-atendimento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/motivo-atendimento/MotivoAtendimentoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-motivo-atendimento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/motivo-atendimento/MotivoAtendimentoManage.vue')
                    },
                ]
            }
        ]
    },
    {
        path: '/ven/crm/funil',
        name: 'ven-funil',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/funil/Funil.vue'),
        children: [
            {
                path: 'list',
                name: "ven-funil-list",
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/funil/FunilList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-funil-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/funil/FunilManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-funil-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/funil/FunilManage.vue')
                    },
                ]
            }
        ]
    },
    // formulario antigo
    {
        path: '/ven/formulario/consulta',
        name: 'ven-formulario-consulta',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/formulario/old/Formulario.vue'),
        children: [
            {
                path: 'list',
                name: "ven-formulario-consulta-list",
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/formulario/old/FormularioList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-formulario-consulta-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/old/FormularioManage.vue'),
                    },
                    {
                        path: 'new/:id',
                        name: 'ven-formulario-consulta-duplicate-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/old/FormularioManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-formulario-consulta-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/old/FormularioManage.vue'),
                    },
                ]
            }
        ]
    },
    {
        path: '/ven/formulario/formularios',
        name: 'ven-formulario',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/formulario/FormularioRoute.vue'),
        children: [
            {
                path: 'list',
                name: "ven-formulario-list",
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/formulario/FormularioList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-formulario-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                    {
                        path: 'new/:id',
                        name: 'ven-formulario-duplicate-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-formulario-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                ]
            }
        ]
    },
    {
        path: '/ven/formulario/formulario-respondido',
        name: 'ven-formulario-respondido',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/relatorio/formulario/RespostaFormularioList.vue'),
        children: [
            {
                path: 'view/:idFormulario',
                name: 'ven-formulario-respondido-view',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/relatorio/formulario/CockpitRespostaFormulario.vue')
            },
        ]
    },

    // formulario respondido antigo
    {
        path: '/ven/formulario/formulario-respondido-consulta',
        name: 'ven-formulario-respondido-consulta',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/relatorio/formulario/old/FormulariosResultados.vue')
    },
    {
        path: '/ven/formulario/formulario-respondido-consulta/:id',
        name: 'ven-formulario-respondido-consulta-edit',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/relatorio/formulario/old/FormularioResultado.vue')
    },
];

const rotas = [
    {
        path: '/ven/rotas/rotavisita',
        name: `ven-rotavisitas`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/rotas/RotasVisita.vue'),
        children: [
            {
                path: 'new',
                name: `${context}-new-rotavisita`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/rotas/RotaVisita.vue')
            },
            {
                path: 'edit/:id',
                name: `${context}-edit-rotavisita`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/rotas/RotaVisita.vue')
            },
        ]
    },
];
const politicaComercial = [
    {
        path: '/ven/politica-comercial/regras-desconto',
        name: 'ven-regras-desconto',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/regras-desconto/RegrasDesconto.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-regras-desconto-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/regras-desconto/RegrasDescontoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-regras-desconto-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/regras-desconto/RegrasDescontoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-regras-desconto-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/regras-desconto/RegrasDescontoManage.vue')
                    },
                ]
            },
        ]
    },
]

const financeiro = [
    {
        path: '/ven/financeiro/centro-custo',
        name: 'ven-centro-custo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/financeiro/centro-custo/CentroCusto.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-centro-custo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/financeiro/centro-custo/CentroCustoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-centro-custo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/financeiro/centro-custo/CentroCustoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-centro-custo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/financeiro/centro-custo/CentroCustoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/financeiro/contas-receber',
        name: 'ven-contas-receber',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/financeiro/contas-receber/ContasReceber.vue'),
        children: [
            {
                path: 'list',
                name: 'ven-contas-receber-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/financeiro/contas-receber/ContasReceberList.vue'),
                children: [
                    {
                        path: 'detail/:id',
                        name: 'ven-contas-receber-detail',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/financeiro/contas-receber/ContasReceberDetail.vue'),
                    },
                    {
                        path: 'chart',
                        name: 'ven-contas-receber-chart',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/financeiro/contas-receber/ContasReceberChart.vue'),
                    },
                ]
            },
        ]
    },
    {
        path: '/ven/financeiro/motivo',
        name: 'ven-motivo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/motivo/Motivo'),
        children: [
            {
                path: 'list',
                name: 'ven-motivo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/motivo/MotivoList'),
                children: [
                    {
                        path: 'new',
                        name: 'ven-motivo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/motivo/MotivoManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'ven-motivo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/motivo/MotivoManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/ven/financeiro/flex',
        name: 'flex',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/financeiro/flex/FlexRoute'),
        children: [
            {
                path: 'list',
                name: 'flex-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/financeiro/flex/FlexList'),
            },
            {
                path: 'detail/:id',
                name: 'flex-detail',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/financeiro/flex/FlexDetail'),
                children: [
                    {
                        path: 'geral',
                        name: `flex-detail-geral`,
                        meta: { contexto: context },
                        component: () => import('@/components/vendas/financeiro/flex/abas/Geral.vue'),
                    },
                ]
            }
        ]
    }
];

export default [
    { // COCKPIT
        path: '/ven/cockpit',
        name: 'ven-cockpit',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/cockpit/CockpitVendas.vue')
    },
    {
        path: '/ven/cockpit/chart/:tipo',
        name: 'ven-cockpit-chart',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/cockpit/CockpitChartVendas.vue')
    },
    ...empresas,
    ...clientes,
    ...produtos,
    ...rotas,
    ...vendas,
    ...crm,
    ...geoanalise,
    ...relatorios,
    ...relatorioIntegradoErp,
    ...financeiro,
    ...politicaComercial,
    {
        path: '/ven/objetivos/objetivovenda',
        name: 'venda-objetivo-venda',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/objetivo/ObjetivoVendas.vue')
    },
];
